'use client'

import { Phone } from 'lucide-react'

import { minimizeVoisoSoftphone, openVoisoSoftphone, useVoisoPanel } from './voisoPanel'
import { Button, SimpleTooltip } from '@fp/ui-kit'
import { commonIconProps } from '@lib/iconProps'

/** Top-nav toggle, next to the notification bell. The agent's Voiso status shows inside the panel itself. */
export const VoisoNavButton = () => {
  const { expanded } = useVoisoPanel()

  return (
    <SimpleTooltip content='Voiso'>
      <Button
        variant='ghost'
        size='sm'
        className='h-8 w-8 p-0'
        aria-label='Voiso'
        aria-expanded={expanded}
        aria-controls='voiso-softphone'
        onClick={expanded ? minimizeVoisoSoftphone : openVoisoSoftphone}
      >
        <Phone {...commonIconProps} />
      </Button>
    </SimpleTooltip>
  )
}
